// extracted by mini-css-extract-plugin
module.exports = {"agents":"Agents__agents--QU","placeholder":"Agents__placeholder--iZ","loader":"Agents__loader--st"};